// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'lib-flexible'
import ElementUI from 'element-ui'

import Vant from 'vant'
import 'vant/lib/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import './request/http'

import { Toast } from 'vant'
Toast.setDefaultOptions('loading', { forbidClick: true })

import vDrag from '@/directive/drag'
Vue.directive('drag', vDrag)
Vue.use(ElementUI)
Vue.use(Vant)

Vue.config.productionTip = false

// 日志输出(开发环境才有)
import VConsole from 'vconsole'
if (process.env.NODE_ENV == 'development') new VConsole()

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js